import { createRouter, createWebHistory } from 'vue-router'
import { getAuth } from 'firebase/auth';

import { showcaseRoutes } from './showcaseRoutes';
import { appRoutes } from './appRoutes';
import { waitForAuthReady } from '@/utils/authReady';
import { getUserById } from "@/services/userService"; // Ajoute cet import

const routes = [
  ...showcaseRoutes, // Routes pour le site showcase
  ...appRoutes,     // Routes pour l'application principale
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Toujours faire défiler vers le haut
    return { top: 0 }
  }
});

// Navigation guard pour protéger les routes
router.beforeEach(async (to, from, next) => {
  await waitForAuthReady();
  const auth = getAuth();
  const user = auth.currentUser;

  if (to.meta.requiresAuth) {
    if (!user) {
      next({ name: 'login' });
    } else {
      // Ajoute cette partie :
      const userDoc = await getUserById(user.uid);
      if (userDoc.requiresEmailVerification && !user.emailVerified) {
        next({ name: 'login', query: { verify: 'true' } });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router